import { GraphData } from 'utils/types'

interface CountMap {
  [key: string]: number
}

interface CountItem {
  key: string
  label: string
}

const getArrayWithCounts = (arr: string[]): CountItem[] => {
  const counts: CountMap = {}
  const countsArray: CountItem[] = []

  arr.forEach(el => {
    counts[el] = (counts[el] || 0) + 1
  })

  Object.keys(counts).forEach(key => {
    countsArray.push({
      key,
      label: `${key} (${counts[key]})`,
    })
  })

  return countsArray
}

export const getLabels = (graph: GraphData): CountItem[] => {
  const labels: string[] = []

  graph.nodes.forEach(node => {
    if (node.data?.labels && Array.isArray(node.data.labels)) {
      labels.push(...node.data.labels)
    }
  })

  return getArrayWithCounts(labels)
}

export const getTypes = (graph: GraphData): CountItem[] => {
  const types: string[] = []

  graph.edges.forEach(edge => {
    if (edge.data?.type && Array.isArray(edge.data.type)) {
      types.push(...edge.data.type)
    }
  })

  return getArrayWithCounts(types)
}
